export enum ProjectType {
  REGULAR = 'REGULAR',
  SYSTEM = 'SYSTEM',
}
